import { AHIcon, AHText, ListItem, TouchableBox } from "arkh";
import React, { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { WorkspaceRoutineTemplateItemRowContainer } from "./WorkspaceRoutineItemRowContainer";
import { ListItemDescriptionContent } from "../../../Team/TeamHomeNavigator/TeamScheduleListItem/ListItemDescriptionContent";

import { WorkspaceDifferentOwnerIndicator } from "../../WorkspaceDifferentOwnerIndicator";
import { WorkspaceRoutineTemplateListItemContent_routine$key } from "./__generated__/WorkspaceRoutineTemplateListItemContent_routine.graphql";
import { WorkspaceRoutineTemplateListItem_Routine$key } from "./__generated__/WorkspaceRoutineTemplateListItem_Routine.graphql";

export function WorkspaceRoutineTemplatesListItem(props: {
  workspaceRoutine: WorkspaceRoutineTemplateListItem_Routine$key;
  isLast: boolean;
  openTemplateDetail: (routineId: string) => void;
  openRoutineEdit: (routineId: string) => void;
  hasTopics: boolean;
}) {
  const item = useFragment(
    graphql`
      fragment WorkspaceRoutineTemplateListItem_Routine on Routine {
        id
        isWorkspaceOwner(workspaceId: $workspaceId)
        workspaceOwnerName(workspaceId: $workspaceId)
        orgTopic {
          name
        }
        ...WorkspaceRoutineTemplateListItemContent_routine
      }
    `,
    props.workspaceRoutine
  );

  const onPress = useCallback(() => {
    props.openTemplateDetail(item.id);
  }, [item.id, props]);

  return (
    <ListItem border="border-primary" isLast={props.isLast} onPress={onPress}>
      <WorkspaceDifferentOwnerIndicator name={item.workspaceOwnerName} />
      <WorkspaceRoutineTemplateItemRowContainer
        title={<WorkspaceRoutineTemplateListItemContent routine={item} />}
        topic={props.hasTopics ? <AHText>{item.orgTopic?.name}</AHText> : null}
        more={
          item.isWorkspaceOwner ? (
            <TouchableBox
              onPress={() => props.openRoutineEdit(item.id)}
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AHIcon type="more-vertical" color="darkText" />
            </TouchableBox>
          ) : (
            <AHIcon type="locked" color="darkText" size="xsmall" />
          )
        }
      />
    </ListItem>
  );
}

function WorkspaceRoutineTemplateListItemContent(props: {
  routine: WorkspaceRoutineTemplateListItemContent_routine$key;
}) {
  const routine = useFragment(
    graphql`
      fragment WorkspaceRoutineTemplateListItemContent_routine on Routine {
        title
        description
        descriptionImages {
          ...ListItemDescriptionContent_images
        }

        descriptionFiles {
          ...ListItemDescriptionContentFiles_files
        }
      }
    `,
    props.routine
  );

  return (
    <ListItemDescriptionContent
      files={routine.descriptionFiles}
      images={routine.descriptionImages ?? []}
      title={routine.title}
      description={routine.description}
      products={[]}
    />
  );
}
